import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Nav from 'react-bootstrap/lib/Nav';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { connect } from 'react-redux';

// Modals
import LoginModal from '../LoginModal';
import SignupModal from '../SignupModal';
import ForgotPassword from '../ForgotPassword';
import HeaderModal from '../HeaderModal';
import NavLink from '../NavLink';
import DropDownMenu from '../DropDownMenu/DropDownMenu';

// Locale
import messages from '../../locale/messages';
import { openHeaderModal } from '../../actions/modalActions';
import { choseToTheme } from '../../actions/getCurrencyRates';


//Images
import gobalIcon from '/public/SiteIcons/gobalIcon.svg'
import SearchForm from '../Home/SearchForm/SearchForm';
import gobalIconTwo from '/public/SiteIcons/gobalIconTwo.svg';
import lightMode from '/public/SiteIcons/lightModeIcon.svg';
import darkMode from '/public/SiteIcons/darkModeIcon.svg';
import { DarkModeIcon, LightModeIcon } from '../Common/Assets/SvgComponent/SiteAdminSvgIcon';
import blackLightMode from '/public/SiteIcons/blackLightMode.svg'
import whatsapp from '/public/SiteImages/whatsapp.svg';

import history from '../../core/history';
import s from './NavigationBeforeLogin.css';
class NavigationBeforeLogin extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    openLoginModal: PropTypes.any,
    openSignupModal: PropTypes.any,
    isTransparentHeader: PropTypes.bool,
  };

  static defaultProps = {
    homeHeaderOnly: false,
  };

  render() {
    const { openLoginModal, openSignupModal, openHeaderModal, layoutType, choseToTheme, selectedTheme } = this.props;
    const { homeHeaderOnly, homePage, page, phoneNumber, isTransparentHeader } = this.props;

    const isWhyHost = history.location && history.location.pathname.startsWith('/whyhost');
    const isHomeHeader = homePage === true;
    const btnColor = ((isHomeHeader && isTransparentHeader)) ? '#ffffff' : 'var(--primary-color)';
    const whatssapLink = `https://api.whatsapp.com/send?phone=${phoneNumber?.replace(' ', '')}&text=¡Hola!%20Podrías%20darme%20más%20información%20de...`;
    return (
      <div>
        <LoginModal />
        <SignupModal />
        <ForgotPassword />
        <HeaderModal modalType={'languageModal'} />
        <HeaderModal modalType={'currencyModal'} />
        <Nav pullRight className={cx('beforeAfterLoginMenuListFlex', (layoutType == 2 ? 'layout2Padding' : ''))}>

          <NavLink to="/" className={cx("hidden-lg", s.newMenuDesign)}>
            <FormattedMessage {...messages.home} />
          </NavLink>
          <NavLink
            noLink
            onClick={(e) => openHeaderModal('languageModal')}
            className={cx(s.breakPointScreen, "hidden-lg")}
          >
            <FormattedMessage {...messages.languageCurrency} />
          </NavLink>
          <NavLink to="/whyhost" className={cx("hidden-lg", 'hideOnFixedHeader')}>
            <FormattedMessage {...messages.becomeAHost} />
          </NavLink>
          <NavLink to="#" noLink onClick={openLoginModal} className={cx("hidden-lg")}>
            <FormattedMessage {...messages.login} />
          </NavLink>
          <NavLink to="#" noLink onClick={openSignupModal} className={cx("hidden-lg")}>
            <FormattedMessage {...messages.signup} />
          </NavLink>
          <NavLink to="/help" className={cx("hidden-lg")}>
            <FormattedMessage {...messages.help} />
          </NavLink>
          <NavLink to="#" className={cx("hidden-lg")} onClick={() => { choseToTheme('light') }}>
            <span className={cx(s.themeIconAlignment, { [s.selectedThemeColor]: selectedTheme === "light" })}>
              <FormattedMessage {...messages.lightMode} />
              <LightModeIcon className={cx(s.themeIcon, 'themeIconRTL')} />
            </span>
          </NavLink>
          <NavLink to="#" className={cx("hidden-lg")} onClick={() => { choseToTheme('dark') }}>
            <span className={cx(s.themeIconAlignment, { [s.selectedThemeColor]: selectedTheme === "dark" })}>
              <FormattedMessage {...messages.darkMode} />
              <DarkModeIcon className={cx(s.themeIcon, 'themeIconRTL')} />
            </span>
          </NavLink>
          <div className={cx('centerMenu', s.tabViewHidden)}>
            {/* {homeHeaderOnly &&
              <div className={cx('scrollOff', s.paddingTop, (layoutType == 2 ? 'layout2CenterPadding' : ''))}>
                <NavLink to="/#" className={cx(s.centerLink, s.dot, 'centerLinkRTL', 'dotRTL', (layoutType == 2 ? 'centerLink2' : ''), (layoutType == 2 ? 'dot2' : ''))}>
                  <FormattedMessage {...messages.placesToStay} />
                </NavLink>
                <NavLink to="/whyhost" className={cx(s.centerLink, 'centerLinkRTL', (layoutType == 2 ? 'centerLink2' : ''))}>
                  <FormattedMessage {...messages.becomeAHost} />
                </NavLink>
              </div>
            } */}
            {
              layoutType && layoutType == 5 && <div className={cx('layout5Css', 'scrollOn')}>
                <SearchForm id={'beforeLogin'} />
              </div>
            }
          </div>
         {/*  {!homeHeaderOnly && !homePage && <div className={cx(s.floatLeft, 'hidden-xs', 'floatRight', s.tabViewHidden, s.dFlex, s.mh10)}>
            <NavLink
              noLink
              onClick={() => window.open(whatssapLink, '_blank')}
              className={cx(s.disPlayInline)}
            >
              <img src={whatsapp} alt='l' />
            </NavLink>
          </div>
          }
          {
            homePage &&
            <NavLink
              onClick={() => window.open(whatssapLink, '_blank')}
              className={cx(s.mbTop, s.nonBreakPointScreen)}>
              {

                <img src={whatsapp} alt='' />
              }
            </NavLink>
          } */}
          {/* {homePage &&
            <NavDropdown title={
              <>
                {

                  (selectedTheme && selectedTheme === "light" && (layoutType && layoutType != 2)) &&
                  <>
                    <img src={lightMode} alt='' className='scrollOff' />
                    <img src={blackLightMode} className={cx('scrollOn')} />
                  </>
                }
                {
                  (selectedTheme && selectedTheme === "light" && (layoutType && layoutType == 2)) &&
                  <img src={blackLightMode} alt='' />

                }
                {
                  (selectedTheme && selectedTheme === "dark") &&
                  <img src={darkMode} alt='' />
                }
              </>
            }

              noCaret id="basic-nav-dropdown1" className={cx('hidden-xs', 'hidden-md', 'hidden-sm', s.nonBreakPointScreen, 'themeIconDropDown', 'hidden-xs', 'hidden-sm', 'hidden-md')}>
              <NavLink to="#" onClick={() => { choseToTheme('light') }} className={'themeIconDropDownLink'}>
                <div className={cx({ [s.selectedThemeColor]: selectedTheme === "light" }, s.themeIconSec)}>
                <LightModeIcon className={cx(s.themeIcon, 'themeIconRTL')} />
                  <FormattedMessage {...messages.lightMode} />
                </div>
              </NavLink>
              <NavLink to="#" onClick={() => { choseToTheme('dark') }} className={'themeIconDropDownLink'}>
                <div className={cx({ [s.selectedThemeColor]: selectedTheme === "dark" }, s.themeIconSec)}>
                  <DarkModeIcon className={cx(s.themeIcon, 'themeIconRTL')} />
                  <FormattedMessage {...messages.darkMode} />
                </div>
              </NavLink>
            </NavDropdown>
          } */}
           {/* {homeHeaderOnly &&
          <div className={cx(s.floatLeft, 'hidden-xs', 'floatRight', s.tabViewHidden, s.dFlex, 'hideOnFixedHeader')}>
            <NavLink to="/whyhost" className={cx(s.centerLink, 'centerLinkRTL', (layoutType == 2 ? 'centerLink2' : ''))}>
              <FormattedMessage {...messages.becomeAHost} />
            </NavLink>
          </div>
        } */}
          {homeHeaderOnly && <span className={cx(s.divider, 'hidden-xs', s.tabViewHidden)} />}
          {/* {!homeHeaderOnly && !homePage && <div className={cx(s.floatLeft, s.tabViewHidden, 'floatRight', s.languageFlex)}>
            <NavLink
              noLink
              onClick={(e) => openHeaderModal('languageModal')}
              className={cx(s.breakPointScreen, s.disPlayInline)}
            >
              <img src={gobalIconTwo} />
            </NavLink>
          </div>
          }
          {homePage &&
            <NavLink
              noLink
              onClick={(e) => openHeaderModal('languageModal')}
              className={cx(s.breakPointScreen, s.mbTop, s.tabViewHidden)}
            >
              {
                layoutType != 2 && <span>
                  <img src={gobalIcon} className={cx('scrollOff', s.tabViewHidden)} />
                  <img src={gobalIconTwo} className={cx('scrollOn')} />

                </span>
              }
              {
                layoutType && layoutType == 2 && <span>
                  <img src={gobalIconTwo} />
                </span>
              }
            </NavLink>
          } */}
          <NavDropdown
            className={cx(s.tabViewHidden, s.paddingDropDown, 'rtlDropDownPaddingHeader')} eventKey={3} title={
              <DropDownMenu isTransparentHeader={isTransparentHeader} />
            } noCaret id="basic-nav-dropdown"
          >

            <NavLink to="#" noLink onClick={openLoginModal}>
              <FormattedMessage {...messages.login} />
            </NavLink>
            {page && <NavLink to="/whyhost" className={cx(s.disPlayInline, s.innerLink, 'innerLinkRTL')}>
              <FormattedMessage {...messages.becomeAHost} />
            </NavLink>}
            <NavLink to="#" noLink onClick={openSignupModal}>
              <FormattedMessage {...messages.signup} />
            </NavLink>
            <NavLink to="/help">
              <FormattedMessage {...messages.help} />
            </NavLink>
            <MenuItem
              to="#"
              onClick={() => window.open(whatssapLink, '_blank')}>
              <div className={cx(s.themeIconAlignment)}>
                <FormattedMessage {...messages.whatsapp} />
                <img src={whatsapp} alt='' />
              </div>
            </MenuItem>

            <MenuItem
              to="#"
              onClick={(e) => openHeaderModal('languageModal')}
            >
              <div className={cx(s.themeIconAlignment)}>
                <FormattedMessage {...messages.globalTwo} />
                <img src={gobalIconTwo} />
              </div>
            </MenuItem>

            <NavLink to="#" onClick={() => { choseToTheme('light') }} className={'textDecorationNone'}>
              <div className={cx(s.themeIconAlignment, s.textColor, { [s.selectedThemeColor]: selectedTheme === "light" })}>
                <FormattedMessage {...messages.lightMode} />
                <LightModeIcon className={cx(s.themeIcon, 'themeIconRTL')} />
              </div>
            </NavLink>
            <NavLink to="#" onClick={() => { choseToTheme('dark') }} className={'textDecorationNone'}>
              <div className={cx(s.themeIconAlignment, s.textColor, { [s.selectedThemeColor]: selectedTheme === "dark" })}>
                <FormattedMessage {...messages.darkMode} />
                <DarkModeIcon className={cx(s.themeIcon, 'themeIconRTL')} />
              </div>
            </NavLink>
          </NavDropdown>
          <NavLink to="#" noLink onClick={openLoginModal} className={cx(s.tabViewHidden, 'floatRight', s.loginBtnWrapper)}>
            <div className={s.loginBtn} style={{ color: btnColor }}>
            <FormattedMessage {...messages.login} />
            </div>
          </NavLink>
        </Nav>

      </div>
    );
  }
}

const mapState = state => ({
  baseCurrency: state?.currency?.base,
  toCurrency: state?.currency?.to,
  currentLocale: state?.intl?.locale,
  layoutType: state?.siteSettings?.data?.homePageType,
  selectedTheme: state?.currency?.theme

});
const mapDispatch = {
  openHeaderModal,
  choseToTheme
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
)(NavigationBeforeLogin);